<script lang="ts">
	import ImageView from "@reperio-news/core.components/ImageView.svelte";
	import { fetchSectionNews, formatNewsDate, NEWS_LIMIT, trackFinance } from "./finance.js";

	export let domain;
	export let tags: string[] = [];
	export let limit: number = NEWS_LIMIT;
	//	which modal tab the list sits under — reported as the GA event category
	export let section: string = null;

	//	no skeleton on purpose: the list must never reserve space for articles
	//	that may not exist — it simply appears under the table once loaded
	let items = [];
	let requestKey = "";

	$: load(tags, limit, domain);

	async function load(tags, limit, domain) {
		const key = JSON.stringify([tags, limit, domain]);
		if (key === requestKey) {
			return;
		}
		requestKey = key;
		items = [];
		const result = await fetchSectionNews(tags, limit, domain);
		//	a later tag change wins over a slow earlier response
		if (key === requestKey) {
			items = result;
		}
	}
</script>

{#if items.length}
	<div class="news">
		<h4>Știri recente</h4>
		<ul>
			{#each items as item, i (item.id)}
				<li>
					<a href={item.url} on:click={() => trackFinance("news_click", section, item.url, { position: i + 1 })}>
						<span class="thumb" class:empty={!item.poster}>
							{#if item.poster}
								<ImageView
									src={item.poster}
									crop={item.poster.crop}
									widths={[112]}
									heights={[112]}
									fit="cover"
									loading="lazy"
									alt=""
								/>
							{/if}
						</span>
						<span class="text">
							<span class="title">{item.title}</span>
							{#if item.published_at}
								<time datetime={item.published_at}>{formatNewsDate(item.published_at)}</time>
							{/if}
						</span>
					</a>
				</li>
			{/each}
		</ul>
	</div>
{/if}

<style lang="scss">
	.news {
		margin-top: 18px;
		padding-top: 14px;
		border-top: 1px solid var(--finance-border, #e7edf2);

		h4 {
			margin: 0 0 8px;
			font-size: 11px;
			font-weight: 700;
			letter-spacing: 0.08em;
			text-transform: uppercase;
			color: var(--finance-muted, #667);
		}

		ul {
			list-style: none;
			margin: 0;
			padding: 0;
		}

		li + li {
			border-top: 1px solid var(--finance-subtle, #eef2f6);
		}

		a {
			display: flex;
			align-items: center;
			gap: 12px;
			padding: 8px 4px;
			margin: 0 -4px;
			border-radius: 10px;
			color: inherit;
			text-decoration: none;
			transition: background-color 0.12s ease;

			&:hover,
			&:focus-visible {
				background-color: var(--finance-hover, #f4f7fa);
				outline: none;

				.title {
					color: var(--finance-accent, #0d3b66);
				}
			}
		}

		.thumb {
			flex: 0 0 auto;
			width: 56px;
			height: 56px;
			border-radius: 8px;
			overflow: hidden;
			background-color: var(--finance-subtle, #e9eef3);

			:global(picture),
			:global(img) {
				display: block;
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.text {
			flex: 1 1 auto;
			min-width: 0;
			display: flex;
			flex-direction: column;
			gap: 3px;
		}

		.title {
			font-size: 14px;
			font-weight: 600;
			line-height: 1.3;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
		}

		time {
			font-size: 11.5px;
			color: var(--finance-muted, #667);
			font-variant-numeric: tabular-nums;
		}
	}
</style>
